<div style="display:block;padding-top:10px;">
  <app-data-table [columns]="tableColumns" [value]="salaryHistories"
                  [disableSearch]="true" [rightCaptionTemplate]="rightCaption">
    <ng-template #rightCaption>
      <div *ngIf="editable" class="p-col-12">
        <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Salary History" pTooltip="New Salary History" tooltipPosition="top"
                (click)="onClickAddRow()">
        </button>
      </div>
    </ng-template>

    <ng-template #actionTemplate let-row="row">
      <button *ngIf="editable"
            pButton type="button" class="icon-action" icon="fa fa-pencil"
            pTooltip="Update" tooltipPosition="top"
            (click)="onClickEditRow(row)">
    </button>
    <button *ngIf="editable" pButton type="button" class="icon-negative" icon="fa fa-trash" pTooltip="Delete" tooltipPosition="top"
            (click)="onClickDeleteRow(row)">
    </button>
  </ng-template>

</app-data-table>
</div>

<p-confirmDialog></p-confirmDialog>

<!-- dialog for new Salary History or editing an existing Salary History -->
<p-dialog *ngIf="salaryHistoryToEdit&&editable" [(visible)]="displayDialog" header="Salary History" [dismissableMask]="true" [responsive]="true"
          [modal]="true"
          [style]="PrimeNgConfig.DialogStyle40">
  <form #dialogForm="ngForm">
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label for="position">Position*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-dropdown id="position" name="position" [style]="{ 'overflow': 'visible', 'width': '100%'}" [options]="positionTypeDropDown"
                    [(ngModel)]="salaryHistoryToEdit.positionDescriptionId"
                    required placeholder="Select..."></p-dropdown>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label for="salary">Salary*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <input pInputText id="salary" name="salary" type="text" [style]="{ 'overflow': 'visible', 'width': '100%'}" [(ngModel)]="salaryHistoryToEdit.annualSalary"
               required/>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Effective On*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-calendar name="startOn" dataType="string" [dateFormat]="Format.PcalendarDate" [maxDate]="maxEndOn" icon="fa fa-calendar"
                    showIcon="true" [(ngModel)]="salaryHistoryToEdit.effectiveOn" required [monthNavigator]="true" readonlyInput="true"></p-calendar>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Salary Low Point</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        {{salaryHistoryToEdit.lowPointSalary}}
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Salary High Point</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        {{salaryHistoryToEdit.highPointSalary}}
      </div>
    </div>
  </form>

  <p-footer>
    <div style="text-align:right;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="displayDialog=false"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check"
              label="Add"
              (click)="onClickSaveRow(salaryHistoryToEdit)" [disabled]="!dialogForm.form.valid"></button>
    </div>
  </p-footer>
</p-dialog>

<p-footer>
  <button *ngIf="editable" pButton type="button" class="button-action" icon="fa fa-check" label="Save" (click)="onClickSaveSalaryHistory()"></button>
</p-footer>
